const mEditionBillingPaymentMethodsEditMethod = {
  mEditionBillingPaymentMethodsEditMethod: {
    alerts: {
      updateAcademiaPasarela: {
        error: 'Un error ha ocurrido. Verifica los datos ingresados y vuelve a intentarlo.',
        success: 'El medio de pago fue editado exitosamente.'
      }
    },

    buttonPrimary: 'EDITAR',

    inputs: {
      descripcion: {
        label: 'Descripción',
        placeholder: 'Mi Medio de Pago'
      }
    },

    redirect: 'Espera un momento, serás redireccionado...',
    title: 'Edita tus datos de',

    validation: {
      required: 'Información requerida.'
    }
  }
}

export default mEditionBillingPaymentMethodsEditMethod
